import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { preloadOnce } from '@shared/services/preload-once';
import { LoadUserSubscribedTags, LoadTags } from '../store/tag.actions';

/* kz2: dispatch the load ONCE and open the route on its first answer — an empty list included
   (see `preloadOnce`). The old guard re-dispatched while the list stayed empty and never opened. */
@Injectable()
export class TagPreloadGuard {
  constructor(private store: Store) {}

  canActivate(): Observable<boolean> {
    return preloadOnce(this.store, state => state.tagState?.tags, [new LoadTags(), new LoadUserSubscribedTags()]);
  }
}
